import { render, staticRenderFns } from "./ModalSendFeedback.vue?vue&type=template&id=464cc37a&scoped=true&"
import script from "./ModalSendFeedback.vue?vue&type=script&lang=js&"
export * from "./ModalSendFeedback.vue?vue&type=script&lang=js&"
import style0 from "./ModalSendFeedback.vue?vue&type=style&index=0&id=464cc37a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464cc37a",
  null
  
)

export default component.exports